import {
	CONTRACT_TEAMS_ERROR,
	CONTRACT_TEAM_COUNT,
	CONTRACT_TEAM_GET,
	CONTRACT_TEAM_GET_ALL,
	CONTRACT_TEAM_ADD_UPDATE,
	CONTRACT_TEAM_APPLY_MULTI_EDIT,
	CONTRACT_TEAM_SAVE,
	CONTRACT_TEAM_CLEAR,
	CONTRACT_TEAM_CLEAR_ALL_UPDATES,
	CONTRACT_TEAM_TEMPLATE_GET,
	CONTRACT_TEAM_AMENDMENTS,
	CONTRACT_TEAM_REMOVE_ALL_EDITS,
	CONTRACT_TEAM_GET_REFINE,
	CONTRACT_TEAM_REFINE_CLEAR,
	CONTRACT_TEAM_GET_GROUP_UPDATER,
	CONTRACT_TEAM_GROUP_UPDATER_FILTER,
	CONTRACT_TEAM_GROUP_UPDATER_CLEAR,
	CONTRACT_TEAM_GROUP_UPDATER_UPDATES,
	CONTRACT_TEAM_REFINE_FILTERS_CLEAR
} from '../Enums/Contract.Teams.Enums';

const initState = {
	data: [],
	dataCopy: [],
	all_data: [],	
	total: 0,
	errors: [],
	updated: [],
	hasUpdates: false,
	lockedReleasedTeams: [],
	editableReleasedTeams: [],
	editStatuses: {},
	count: { total: 0, complete: 0 },
	isLoaded: false,
	message: '',
	templateData: [{ value: '', label: '', name: '' }],
	isDataAPICallCompleted: false,
	selectedTypes: [],
	selectedTeamIds: [],
	selectedTemplateId: [],
	selectedContractStatus: [],
	selectedMarkingMethod: [],
	inputTitle: '',
	inputMarkingTeamCode: '',
	refineData: [],
	groupUpdaterData: [],
	isGroupUpdaterFilter: false,
	groupUpdaterTypes: [],
	groupUpdaterTeamIds: []
};

const teams = (state = initState, action) => {
	let updatedState = {};
	const { type, payload = {} } = action;
	const { message, errors, data, dataCopy, selectedTypes, selectedTeamIds, selectedTemplateId, selectedContractStatus, selectedMarkingMethod, inputTitle, inputMarkingTeamCode, refineData, groupUpdaterData, isGroupUpdaterFilter, groupUpdaterTypes, groupUpdaterTeamIds } = payload;

	switch (type) {
		case CONTRACT_TEAM_COUNT:
			updatedState = {
				...state,
				count: data,
				errors,
				isLoaded: true
			};
			break;
		case CONTRACT_TEAMS_ERROR:
			updatedState = {
				...state,
				errors,
				isLoaded: true,
				isDataAPICallCompleted: true
			};
			break;
		case CONTRACT_TEAM_GET:
			updatedState = {
				...state,
				data,
				dataCopy,
				total: payload.total,
				lockedReleasedTeams: [],
				editableReleasedTeams: [],
				editStatuses: {},
				errors,
				isDataAPICallCompleted: true,
				message: '',
				selectedTypes,
				selectedTeamIds,
				selectedTemplateId,
				selectedContractStatus,
				selectedMarkingMethod,
				inputTitle,
				inputMarkingTeamCode
			};
			break;
		case CONTRACT_TEAM_GET_ALL:
			updatedState = {
				...state,
				all_data: data,
				errors
			};
			break;
		case CONTRACT_TEAM_AMENDMENTS:
			updatedState = {
				...state,
				lockedReleasedTeams: payload.lockedReleasedTeams,
				editableReleasedTeams: payload.editableReleasedTeams,
				editStatuses: payload.editStatuses,
				errors: payload.errors
			};
			break;
		case CONTRACT_TEAM_ADD_UPDATE:
			updatedState = {
				...state,
				updated: action.payload.updated,
				hasUpdates: action.payload.updated.length > 0,
				errors: action.payload.errors,
				message: ''
			};
			break;
		case CONTRACT_TEAM_APPLY_MULTI_EDIT:
			updatedState = {
				...state,
				data: action.payload.data,
				updated: action.payload.updated,
				errors: action.payload.errors
			};
			break;
		case CONTRACT_TEAM_SAVE:
			updatedState = {
				...state,
				data,
				dataCopy,
				hasUpdates: false,
				errors,
				message,
				updated: [],
				groupUpdaterData
			};
			break;
		case CONTRACT_TEAM_CLEAR:
			updatedState = {
				...state,
				errors,
				message: ''
			};
			break;
		case CONTRACT_TEAM_CLEAR_ALL_UPDATES: 
			updatedState = {
				...state,
				data: [],
				dataCopy: [],
				all_data: [],
				updated: [],
				hasUpdates: false,
				isDataAPICallCompleted: false,
				lockedReleasedTeams: [],
				editableReleasedTeams: [],
				editStatuses: {},
				errors: [],
				message: '',
				selectedTypes: [],
				selectedTeamIds: [],
				selectedTemplateId: [],
				selectedContractStatus: [],
				selectedMarkingMethod: [],
				inputTitle: '',
				inputMarkingTeamCode: '',
				refineData: [],
				groupUpdaterData: [],
				isGroupUpdaterFilter: false,
				groupUpdaterTypes: [],
				groupUpdaterTeamIds: []
			};
			break;
		case CONTRACT_TEAM_REMOVE_ALL_EDITS: 
			updatedState = {
				...state,
				data: payload.data,
				updated: [],
				hasUpdates: false
			};
			break;
		case CONTRACT_TEAM_TEMPLATE_GET:
			updatedState = {
				...state,
				templateData: payload.data,
				errors: payload.errors,
				message: payload.message
			};
			break;
		case CONTRACT_TEAM_GET_REFINE:
			updatedState = {
				...state,
				refineData,
				errors
			};
			break;
		case CONTRACT_TEAM_REFINE_CLEAR:
			updatedState = {
				...state,
				refineData: []
			};
			break;
		case CONTRACT_TEAM_GET_GROUP_UPDATER:
			updatedState = {
				...state,
				groupUpdaterData,
				errors
			};
			break;
		case CONTRACT_TEAM_GROUP_UPDATER_FILTER:
			updatedState = {
				...state,
				isGroupUpdaterFilter,
				groupUpdaterTypes,
				groupUpdaterTeamIds
			};
			break;
		case CONTRACT_TEAM_GROUP_UPDATER_UPDATES:
			updatedState = {
				...state,
				groupUpdaterData
			};
			break;
		case CONTRACT_TEAM_GROUP_UPDATER_CLEAR:
			updatedState = {
				...state,
				groupUpdaterData: [],
				isGroupUpdaterFilter: false,
				groupUpdaterTypes: [],
				groupUpdaterTeamIds: []
			};
			break;
		case CONTRACT_TEAM_REFINE_FILTERS_CLEAR:
			updatedState = {
				...state,
				selectedTemplateId: [],
				selectedContractStatus: [],
				selectedMarkingMethod: [],
				inputTitle: '',
				inputMarkingTeamCode: ''
			};
			break;
		default:
			return state;
	}

	return updatedState;
};

export default teams;
